"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _vuex = require("vuex");
var _previewBox = _interopRequireDefault(require("./previewBox"));
var _info = _interopRequireDefault(require("./info"));
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _product = require("@/api/retailer/product");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var headerName = [{
  name: '出售中商品',
  type: 1
}, {
  name: '已下架商品',
  type: 2
}, {
  name: '产品库',
  type: 3
}];
var _default = exports.default = {
  name: 'MerchantProductList',
  components: {
    infoFrom: _info.default,
    previewBox: _previewBox.default,
    merchantName: _merchantName.default
  },
  data: function data() {
    return {
      componentKey: 0,
      isAtud: false,
      isShow: false,
      productId: 0,
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      isShowSeach: true,
      categoryIdData: [],
      headeNum: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        categoryId: null,
        keywords: '',
        type: '1',
        isSelf: null,
        merId: null,
        isShow: null,
        retailerId: ''
      },
      options: [{
        value: null,
        label: '全部'
      }, {
        value: 0,
        label: '不可售'
      }, {
        value: 1,
        label: '可售'
      }],
      keywords: '',
      categoryList: [],
      merCateList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      dialogVisible: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '商品图', '商品名称', '商品售价', '商户名称', '渠道售价', '商户类别', '销量', '库存', '审核状态'],
      columnData: ['ID', '商品图', '商品名称', '商品售价', '渠道售价', '商户名称', '商户类别', '销量', '库存', '审核状态'],
      isIndeterminate: true,
      merchantList: [],
      search: {
        limit: 10,
        page: 1,
        keywords: ''
      },
      loading: false,
      totalPage: 0,
      total: 0,
      keyNum: 0,
      multipleSelection: [],
      OffId: [],
      previewVisible: false,
      frontDomainUrl: '',
      // iframe地址
      productStatisticsData: {}
    };
  },
  mounted: function mounted() {
    this.goodHeade();
    this.productStatisticsHeader();
    if (!localStorage.getItem('adminProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    this.getList();
    this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['adminProductClassify', 'frontDomain'])), {}, {
    heightBoxs: function heightBoxs() {
      var _this = this;
      this.$nextTick(function () {
        // 页面渲染完成后的回调
        return Number(_this.$refs.headerBox.offsetHeight) - Number(document.documentElement.clientHeight);
      });
    }
  }),
  methods: {
    checkPermi: _permission.checkPermi,
    ishttp: function ishttp(url) {
      return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1;
    },
    // 预览
    handlePreview: function handlePreview(id) {
      this.previewVisible = true;
      /*      if (this.ishttp(this.frontDomain)) {
        this.frontDomainUrl = `${this.frontDomain}/pages/goods/goods_details/index?id=${id}`;
      } else {
        this.frontDomainUrl = `https://${this.frontDomain}/pages/goods/goods_details/index?id=${id}`;
      }*/
      this.frontDomainUrl = 'http://jh5.qmsk.work/static/html/pc.html';
    },
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.subSuccess();
    },
    batchProduct: function batchProduct() {
      var _this2 = this;
      this.$modalSure('全量导入会覆盖商品配置，请慎重！').then(function () {
        (0, _product.merchantProductImport)();
        _this2.getList(1);
      });
    },
    //批量产品导入
    batchProductImport: function batchProductImport() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.handProductImport(this.OffId);
    },
    //产品导入
    handProductImport: function handProductImport(id) {
      var _this3 = this;
      this.$modalSure('确认产品强制导入吗').then(function () {
        (0, _product.productImportShellApi)({
          ids: id.toString(),
          merchantId: '0000'
        }).then(function (res) {
          _this3.$message({
            type: 'success',
            message: '提交成功'
          });
          _this3.subSuccess();
        });
      });
    },
    // 批量下架
    batchOff: function batchOff() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.handleOff(this.OffId);
    },
    // 下架
    handleOff: function handleOff(id) {
      var _this4 = this;
      this.$modalSure('强制下架吗').then(function () {
        (0, _product.offShellApi)({
          ids: id.toString(),
          merchantId: '0000'
        }).then(function (res) {
          _this4.$message({
            type: 'success',
            message: '提交成功'
          });
          _this4.subSuccess();
        });
      });
    },
    // 批量上架
    batchOn: function batchOn() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.handleOn(this.OffId);
    },
    handleOn: function handleOn(id) {
      var _this5 = this;
      this.$modalSure('强制上架吗').then(function () {
        (0, _product.upShellApi)({
          ids: id.toString(),
          merchantId: '0000'
        }).then(function (res) {
          _this5.$message({
            type: 'success',
            message: '提交成功'
          });
          _this5.subSuccess();
        });
      });
    },
    // 批量下架
    batchORemove: function batchORemove() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.handleRemove(this.OffId);
    },
    handleRemove: function handleRemove(id) {
      var _this6 = this;
      this.$modalSure('确定从产品中移除吗').then(function () {
        (0, _product.removeShellApi)({
          ids: id.toString(),
          merchantId: '0000'
        }).then(function (res) {
          _this6.$message({
            type: 'success',
            message: '提交成功'
          });
          _this6.subSuccess();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var data = [];
      this.multipleSelection.map(function (item) {
        data.push(item.pid);
      });
      this.OffId = data;
    },
    subSuccess: function subSuccess() {
      this.getList('');
      this.goodHeade();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this7 = this;
      (0, _product.productHeadersApi)().then(function (res) {
        headerName.map(function (item, index) {
          if (item.type === res[index].type) item.count = res[index].count;
        });
        _this7.headeNum = headerName;
      }).catch(function (res) {
        _this7.$message.error(res.message);
      });
    },
    productStatisticsHeader: function productStatisticsHeader() {
      var _this8 = this;
      (0, _product.productStatisticsHeadersApi)().then(function (res) {
        _this8.productStatisticsData = res;
      }).catch(function (res) {
        _this8.$message.error(res.message);
      });
    },
    // 列表
    getList: function getList(num) {
      var _this9 = this;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      this.listLoading = true;
      (0, _product.merchantProductListApi)(this.tableFrom).then(function (res) {
        _this9.tableData.data = res.list;
        _this9.tableData.total = res.total;
        _this9.listLoading = false;
      }).catch(function (res) {
        _this9.listLoading = false;
        _this9.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    renderHeader: function renderHeader(h) {
      var _this0 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this0.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleAudit: function handleAudit(id, c) {
      this.productId = id;
      this.$refs.infoFrom.dialogVisible = true;
      this.isShow = true;
      this.isAtud = c;
      this.componentKey += 1;
      this.$refs.infoFrom.getInfo(id);
    },
    handleCloseMod: function handleCloseMod(item) {
      this.dialogVisible = item;
      this.goodHeade();
      this.getList();
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};